import React, { useState } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import './Header.scss';
import { Button, Stack } from 'react-bootstrap';

const Header = () => {
    const [showMobileMenu, setShowMobileMenu] = useState(false);

    const toggleMobileMenu = () => {
        setShowMobileMenu(!showMobileMenu);
    };

    return (
        <>
            <Navbar
                expand="md"
                variant='dark'
                className='header'
                onToggle={toggleMobileMenu}
            >
                <Container>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Brand className='header--brand'
                        href="#home">
                        <div className="logo">
                            <img src='/icons/logo.png' />
                        </div>
                    </Navbar.Brand>
                    <Nav className="header--nav">
                        <Nav.Link href="#our-story">Our Story</Nav.Link>
                        <Nav.Link href="#when-where">When and Where</Nav.Link>
                        <Nav.Link href="#gallery">Top Moments</Nav.Link>
                        <Nav.Link href="#gettingthere">Getting There</Nav.Link>
                        <Nav.Link href="#hotels">Hotels</Nav.Link>
                    </Nav>
                    <Nav className="header--nav">
                        <Button className='rspv' variant='light' href='#rspv'>RSPV</Button>
                    </Nav>
                </Container>
            </Navbar>
            <Offcanvas className="offcanvas-menu" show={showMobileMenu} onHide={toggleMobileMenu} onToggle={toggleMobileMenu}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title></Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="offcanvas-menu-body">
                    <Stack className='stack'>
                        <div className="logo-section">
                            <div className="logo">Esme <small>&</small> Carlos</div>
                            <div className="date">22/03/2025</div>
                        </div>
                        <div className='offcanvas-menu-container'>
                            <ul>
                                <li><a onClick={toggleMobileMenu} href='#'>Home</a></li>
                                <li><a onClick={toggleMobileMenu} href='#our-story'>Our Story</a></li>
                                <li><a onClick={toggleMobileMenu} href='#when-where'>When and Where</a></li>
                                <li><a onClick={toggleMobileMenu} href="#gallery">Top Moments</a></li>
                                <li><a onClick={toggleMobileMenu} href="#gettingthere">Getting There</a></li>
                                <li><a onClick={toggleMobileMenu} href="#hotels">Hotels</a></li>
                                <li><a onClick={toggleMobileMenu} href="#rspv">RSPV</a></li>
                            </ul>
                        </div>
                        <div className='offcanvas-menu-footer'>
                            <span className="separator"></span>
                            <p>
                                March 22, 2025, Ajijic<br />
                                See you there
                            </p>
                        </div>
                    </Stack>
                </Offcanvas.Body>
            </Offcanvas>
        </>

    );
};

export default Header;